
import { configureStore } from '@reduxjs/toolkit'

import externalDataReducer from '../ExternalData/externalDataSlice';
import batchReducer from '../Batch/batchSlice';
import batchEventReducer from '../BatchEvent/batchEventSlice';
import stakeholderListReducer from '../ExternalData/StakeholderList/stakeholderListSlice';
import stakeholderListSearchReducer from '../ExternalData/StakeholderList/stakeholderListSearchSlice';
import cdpStatsReducer from '../WorkIssuance/WorkIssuanceStats/cdpStatsSlice.jsx';
import contractReducer from '../Contract/contractSlice';
import contractSearchReducer from '../WorkQueue/Contracts/contractSearchSlice';
import contractHierarchySearchControlsReducer from '../WorkQueue/Header/contractHierarchySearchControlsSlice';
import contractDetailListReducer from '../Contract/ContractListDrawers/contractDetailListSlice';
import contractDataPointReducer from '../ContractDataPoint/contractDataPointSlice';
import contractDataPointValueReducer from '../ContractDataPointValue/contractDataPointValueSlice';
import contractDataPointValueFilterReducer from '../ContractDataPointValueFilter/contractDataPointValueFilterSlice';
import contractSectionReducer from '../ContractSection/contractSectionSlice';
import contractSectionFilterReducer from '../ContractSectionFilter/contractSectionFilterSlice';
import contractStatsReducer from '../WorkQueue/WorkStats/contractStatsSlice';
import contractStatsControlsReducer from '../WorkQueue/WorkStats/contractStatsControlsSlice';
import confirmationReducer from '../WorkIssuance/WorkIssuanceConfirmation/confirmationSlice';
import dataPointReducer from '../DataPoint/dataPointSlice';
import dataPointAttributeReducer from '../DataPointAttribute/dataPointAttributeSlice'
import dataPointValueReducer from '../DataPointValue/dataPointValueSlice';
import dataPointXrefReducer from '../DataPointXref/dataPointXrefSlice'
import crudSnackbarReducer from '../CommonComponents/crudSnackbarSlice';
import expenseReducer from '../WorkIssuance/WorkIssuanceExpense/expenseSlice';
import fringeReducer from '../WorkIssuance/WorkIssuanceFringe/fringeSlice';
import helperReducer from '../ContractDrilldown/ContractDrilldownCS/Helpers/helperSlice';
import mainReducer from '../mainSlice';
import obligationHierarchyReducer from '../WorkIssuance/WorkIssuanceObligation/obligationHierarchySlice';
import offsetsReducer from '../WorkIssuance/WorkIssuanceOffsets/offsetsSlice';
import owedReducer from '../WorkIssuance/WorkIssuanceOwed/owedSlice';
import paymentReducer from '../WorkIssuance/WorkIssuancePayment/paymentSlice';
import requestReducer from '../WorkIssuance/WorkIssuanceRequest/requestSlice';
import rowSelectReducer from '../Menus/rowSelectSlice';
import taxReducer from '../WorkIssuance/WorkIssuanceTax/taxSlice';
import uploadFileReducer from '../CommonComponents/UploadFile/uploadFileSlice';
import workReducer from '../Work/workSlice';
import workIssuanceReducer from '../WorkIssuance/workIssuanceSlice';
import workQueueReducer from '../WorkQueue/workQueueSlice';
import workSubmittingReducer from '../Work/workSubmittingSlice';
import contractDrilldownReducer from '../ContractDrilldown/contractDrilldownSlice';
import contractDrilldownCSReducer from '../ContractDrilldown/ContractDrilldownCS/contractDrilldownSliceCS';
import contractDrilldownExpandCSReducer from '../ContractDrilldown/contractDrilldownSliceExpandCS';
import contractDrilldownCDPReducer from '../ContractDrilldown/ContractDrilldownCDP/contractDrilldownSliceCDP';
import contractDrilldownCDPVReducer from '../ContractDrilldown/ContractDrilldownCDPV/contractDrilldownSliceCDPV';
import contractDrilldownCDPVFReducer from '../ContractDrilldown/ContractDrilldownCDPVF/contractDrilldownSliceCDPVF';
import exchangeReducer from '../ExternalData/Exchange/exchangeSlice';
import exchangeSearchReducer from '../ExternalData/Exchange/exchangeSearchSlice';
import financialReducer from '../ExternalData/Financial/financialSlice';
import financialSearchReducer from '../ExternalData/Financial/financialSearchSlice';
import interestReducer from '../ExternalData/Interest/interestSlice';
import interestSearchReducer from '../ExternalData/Interest/interestSearchSlice';
import licenseReducer from '../ExternalData/License/licenseSlice';
import licenseSearchReducer from '../ExternalData/License/licenseSearchSlice';
import platformReducer from '../ExternalData/Platform/platformSlice';
import platformSearchReducer from '../ExternalData/Platform/platformSearchSlice';
import productReducer from '../ExternalData/Product/productSlice';
import productSearchReducer from '../ExternalData/Product/productSearchSlice';
import profileReducer from '../ExternalData/Profile/profileSlice';
import profileSearchReducer from '../ExternalData/Profile/profileSearchSlice';
import subscriberReducer from '../ExternalData/Subscriber/subscriberSlice';
import subscriberSearchReducer from '../ExternalData/Subscriber/subscriberSearchSlice';
import usageReducer from '../ExternalData/Usage/usageSlice';
import usageSearchReducer from '../ExternalData/Usage/usageSearchSlice';
import userProfileReducer from './userProfileSlice';
import usersReducer from '../Users/usersSlice';
import viewershipReducer from '../ExternalData/Viewership/viewershipSlice';
import viewershipSearchReducer from '../ExternalData/Viewership/viewershipSearchSlice';



export const store = configureStore({
    reducer:
        {
            crudSnackbarSlc: crudSnackbarReducer,
            externalDataSlc: externalDataReducer,
            batchSlc: batchReducer,
            batchEventSlc: batchEventReducer,
            stakeholderListSlc: stakeholderListReducer,
            stakeholderListSearchSlc: stakeholderListSearchReducer,
            cdpStatsSlc: cdpStatsReducer,
            confirmationSlc: confirmationReducer,
            contractSlc: contractReducer,
             contractSearchSlc: contractSearchReducer,
            contractDataPointSlc: contractDataPointReducer,
            contractDataPointValueSlc: contractDataPointValueReducer,
            contractDataPointValueFilterSlc: contractDataPointValueFilterReducer,
            contractHierarchySearchControlsSlc: contractHierarchySearchControlsReducer,
            contractDetailListSlc: contractDetailListReducer,
            contractSectionSlc: contractSectionReducer,
            contractSectionFilterSlc: contractSectionFilterReducer,
            contractStatsSlc: contractStatsReducer,
            contractStatsControlsSlc: contractStatsControlsReducer,
            dataPointSlc: dataPointReducer,
            dataPointAttributeSlc: dataPointAttributeReducer,
            dataPointValueSlc: dataPointValueReducer,
            dataPointXrefSlc: dataPointXrefReducer,
                exchangeSlc: exchangeReducer,
                exchangeSearchSlc: exchangeSearchReducer,
            expenseSlc: expenseReducer,
            fringeSlc: fringeReducer,
            helperSlc: helperReducer,
            mainSlc: mainReducer,
            obligationHierarchySlc: obligationHierarchyReducer,
            offsetsSlc: offsetsReducer,
            owedSlc: owedReducer,
            paymentSlc: paymentReducer,
            requestSlc: requestReducer,
            rowSelectSlc: rowSelectReducer,
            taxSlc: taxReducer,
            uploadFileSlc: uploadFileReducer,
            workSlc: workReducer,
            workIssuanceSlc: workIssuanceReducer,
            workQueueSlc: workQueueReducer,
            workSubmittingSlc: workSubmittingReducer,
            contractDrilldownSlc: contractDrilldownReducer,
            contractDrilldownSlcCS: contractDrilldownCSReducer,
                contractDrilldownSlcCDP: contractDrilldownCDPReducer,
            contractDrilldownSlcCDPV: contractDrilldownCDPVReducer,
            contractDrilldownSlcCDPVF: contractDrilldownCDPVFReducer,
                contractDrilldownSlcExpandCS: contractDrilldownExpandCSReducer,
                financialSlc: financialReducer,
            financialSearchSlc: financialSearchReducer,
                interestSlc: interestReducer,
                interestSearchSlc: interestSearchReducer,
                licenseSlc: licenseReducer,
            licenseSearchSlc: licenseSearchReducer,
                platformSlc: platformReducer,
            platformSearchSlc: platformSearchReducer,
            productSlc: productReducer,
                productSearchSlc: productSearchReducer,
                profileSlc: profileReducer,
            profileSearchSlc: profileSearchReducer,
                subscriberSlc: subscriberReducer,
            subscriberSearchSlc: subscriberSearchReducer,
                usageSlc: usageReducer,
            usageSearchSlc: usageSearchReducer,
            userProfileSlc: userProfileReducer,
            usersSlc: usersReducer,
            viewershipSlc: viewershipReducer,
            viewershipSearchSlc: viewershipSearchReducer

            },
}
)

